import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import CopyText from 'components/copy-text/copy-text.component';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ItemsPopover from '../items-popover/items-popover.component';

const ItemDetailCard = ({ itemData }) => {
  const { t } = useTranslation();

  const isImported: boolean = useMemo(
    () => !!itemData?.externalId,
    [itemData?.externalId],
  );

  function findDisplayInfo(displayInfo) {
    if (!Array.isArray(displayInfo)) {
      return {
        shortDescription: null,
        smallImage: null,
      };
    }

    for (let info of displayInfo) {
      if (
        info.langCode === 'EN' &&
        (info.shortDescription ||
          (info.smallImage && info.smallImage.length > 0))
      ) {
        return {
          shortDescription: info.shortDescription,
          smallImage: info?.smallImage,
        };
      }
    }

    for (let info of displayInfo) {
      if (
        info.shortDescription ||
        (info.smallImage && info.smallImage.length > 0)
      ) {
        return {
          shortDescription: info.shortDescription,
          smallImage: info?.smallImage,
        };
      }
    }

    return {
      shortDescription: null,
      smallImage: null,
    };
  }

  const headerData = findDisplayInfo(itemData?.displayInfo);

  return (
    <Card>
      <CardHeader
        avatar={
          <Avatar
            alt=""
            src={!!headerData?.smallImage ? headerData?.smallImage : ''}
            sx={{ width: 50, height: 50 }}
            data-testid={'ItemDetailImage'}
          />
        }
        title={
          <Stack direction="row" spacing={2} alignItems="flex-start">
            <Typography variant="h2" data-testid={'ItemDetailTitle'}>
              {itemData?.title}
            </Typography>
            {isImported && (
              <Chip
                label={t('forms.itemsForm.itemCard.chip.label')}
                size="small"
                color="info"
              />
            )}
          </Stack>
        }
        action={<ItemsPopover itemData={itemData} />}
      />
      <CardContent>
        <Stack direction="row" alignItems="center">
          <Typography mr={1} variant="h6">
            {t('forms.itemsForm.itemCard.itemId.label')}:
          </Typography>
          <CopyText>{itemData?.itemId}</CopyText>
        </Stack>
        {!!isImported && (
          <Stack direction="row" alignItems="center" mt={1}>
            <Typography mr={1} variant="h6">
              {t('forms.itemsForm.itemCard.externalId.label')}:
            </Typography>
            <CopyText>{itemData?.externalId}</CopyText>
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};
export default ItemDetailCard;
